import React from 'react'
import { BenefitContainer, BenefitImage, BenefitTextContainer, BenefitTitle, BenefitDescription } from './styles'

export default function Benefit({ image, title, description }) {
  return (
    <BenefitContainer>
      <BenefitImage src={image} alt={title} />
      <BenefitTextContainer>
        <BenefitTitle>{title}</BenefitTitle>
        <BenefitDescription>{description}</BenefitDescription>
      </BenefitTextContainer>
    </BenefitContainer>
  )
}
